import { PersonDocument } from 'libs/pre-flight/feature-aircraft-trip/src/lib/_models/person-document.model';
import { DocumentTypeName } from 'libs/shared/documents-images/src/lib/_models/documents/document-type-name.enum';

export const sortUserFacingFullName = (
  firstNameA: string,
  lastNameA: string,
  firstNameB: string,
  lastNameB: string
) => {
  if (lastNameA && lastNameB) {
    const lastNameCompare = lastNameA.localeCompare(lastNameB);
    if (lastNameCompare === 0 && firstNameA && firstNameB) {
      return firstNameA.localeCompare(firstNameB);
    } else {
      return lastNameCompare;
    }
  } else {
    if (lastNameA) {
      return -1;
    } else {
      return 1;
    }
  }
};

export const sortUserFacingString = (stringA: string, stringB: string) => {
  if (stringA && stringB) {
    return stringA.localeCompare(stringB);
  } else {
    if (stringA) {
      return -1;
    } else {
      return 1;
    }
  }
};

export function sortPersonDocumentsPrimaryPassportVisa(documents: PersonDocument[]) {
  let sortedDocuments = documents;
  // if there is a primary passport or visa, make them the first in the list. passport has priority
  if (
    documents.some(
      document =>
        document.documentType === DocumentTypeName.Passport ||
        document.documentType === DocumentTypeName.Visa
    )
  ) {
    sortedDocuments = [];
    let primaryPassport = documents.find(
      document => document.documentType === DocumentTypeName.Passport && document.isPrimary
    );
    let primaryVisa = documents.find(
      document => document.documentType === DocumentTypeName.Visa && document.isPrimary
    );
    let remainingDocuments = documents.filter(
      document =>
        (!primaryPassport || primaryPassport !== document) &&
        (!primaryVisa || primaryVisa !== document)
    );

    if (primaryPassport) sortedDocuments.push(primaryPassport);
    if (primaryVisa) sortedDocuments.push(primaryVisa);
    if (remainingDocuments) sortedDocuments = sortedDocuments.concat(remainingDocuments);
  }

  return sortedDocuments;
}
